import { useI18n } from "@/i18n";
import { SectionShell } from "@/components/section-shell";

// Müşteri grubu: Yorumlar · Sadakat
// Yorumlar her planda var; Sadakat Pro+. Sayfa içi plan gating zaten
// loyalty.tsx tarafında (LoyaltyUpgradePrompt) — burada tabs hep gözükür,
// FREE kullanıcı tıklayınca upgrade card görür.
export function CustomersSection() {
  const { t } = useI18n();
  return (
    <SectionShell
      tabs={[
        { to: ".", label: t("reviews"), end: true },
        { to: "loyalty", label: t("loyalty") },
      ]}
    />
  );
}
